export default __webpack_public_path__ + "static/1a247e0d0da6ad2f550d994d5e8f20c8.jpg";